module.exports = __webpack_public_path__ + "570eb83859dc23dd0eec423a49e147fe.woff2";